<template lang="pug">
    v-container
      v-snackbar(v-model="snackbar" :timeout=8000 :color="snackbar_color" multi-line) {{snackbar_text}}
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    snackbar: false,
    snackbar_text: "error",
    snackbar_color: "error"
  }),
  components: {},

  mounted() {
    this.$watch(
      "error",
      () => {
        if (this.error) {
          this.snackbar = true;
          this.snackbar_text = this.error;
        }
      },
      { immediate: true }
    );
  },
  methods: {},
  computed: {
    ...mapGetters(["error"])
  }
};
</script>